import classNames from "classnames";
import "./TagFilter.scss";
import React from "react";

export interface TagFilterList {
  title: string;
  value: string;
}
export interface TagFilterProps {
  listTag?: TagFilterList[];
  className?: string;
  value?: string;
  onClick?: (value: string) => void;
}

function TagFilter(props: TagFilterProps) {
  const {
    listTag,
    className,
    value,
    onClick,
  } = props;


  return (
    <>
      <div
        className={classNames(
          `tag-filter__container`,
          className
        )}
      >
        {listTag?.map((tag) => {
          return <div className={classNames(
            `tag-filter__item`,
            {
              "active": tag.value === value
            }
          )}
            key={tag.value} onClick={() => onClick(tag.value)}>
            {tag.title}
          </div>
        })}
      </div>

    </>
  );
}

export default TagFilter;
